{
  "version": 1,
  "asset_id": "eed75e63-b0f3-4e44-9fd1-f00414414dd4",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/eed75e63-b0f3-4e44-9fd1-f00414414dd4/sleeve-ugi-reflux-pre-899-es.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/eed75e63-b0f3-4e44-9fd1-f00414414dd4/sleeve-ugi-reflux-pre-899-es.webp",
  "original_filename": "sleeve-ugi-reflux-pre-899-es.webp",
  "size": 48398,
  "content_type": "image/webp",
  "created_at": "2026-09-28T16:44:02Z"
}
